// Define the rules for the alternate HS qualifier

import { County } from "@/models/county";
import { INCOME_RANGE } from "./app-data";

// RuleIndex is 'one or more of the qualifiers applies', the county, and the income range
export type QualifierRuleIndex = [boolean | undefined, County | undefined, INCOME_RANGE | undefined];

export interface QualifierRule {
    index: QualifierRuleIndex;
    path: string; 
}

export function  matchQualifiers(rules: QualifierRule[], applies: boolean, county: County, fpl: INCOME_RANGE): QualifierRule | undefined{
    //console.log(`Find rule that matches: ${applies}, ${county}, ${fpl}`);
    const rule = rules.find( rule => 
        (rule.index[0] == null || rule.index[0] === applies )
        && (rule.index[1] ==  null || rule.index[1] === county)
        && (rule.index[2] == null || rule.index[2] == fpl));

     //console.log(`matchQualifiers: ${applies}, ${county}, ${fpl}, Path --> ${rule?.path}`);
     //console.log('matched on -->', rule?.index[0], rule?.index[1], rule?.index[2])
     //console.log('rules -->', JSON.stringify(rules))

    return rule;
}

